"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlPrefixForLocale = exports.decodeLocaleCode = void 0;
function decodeLocaleCode(localeCode) {
    if (localeCode === undefined)
        throw new Error(`Invalid locale code: undefined`);
    if (localeCode === null)
        throw new Error(`Invalid locale code: null`);
    let regexout = /^([a-z]+)(?:_([A-Z]+))?$/.exec(localeCode);
    if (!regexout)
        throw new Error(`Invalid locale code: '${localeCode}'`);
    let [langCode, countryCode] = regexout.splice(1);
    return { langCode, countryCode };
}
exports.decodeLocaleCode = decodeLocaleCode;
function getUrlPrefixForLocale(localeCode) {
    let { langCode, countryCode } = decodeLocaleCode(localeCode);
    return `/${langCode}/${countryCode}/`;
}
exports.getUrlPrefixForLocale = getUrlPrefixForLocale;
//# sourceMappingURL=locales.js.map